export const premadeThumbnailList = [
  [
    'https://d2jefos38oys06.cloudfront.net/fit-in/203x114/production/premade-thumbnails/1.webp',
    'https://d2jefos38oys06.cloudfront.net/fit-in/203x114/production/premade-thumbnails/2.webp',
    'https://d2jefos38oys06.cloudfront.net/fit-in/203x114/production/premade-thumbnails/3.webp',
    'https://d2jefos38oys06.cloudfront.net/fit-in/203x114/production/premade-thumbnails/4.webp',
    'https://d2jefos38oys06.cloudfront.net/fit-in/203x114/production/premade-thumbnails/5.webp',
    'https://d2jefos38oys06.cloudfront.net/fit-in/203x114/production/premade-thumbnails/6.webp',
  ],
  [
    'https://d2jefos38oys06.cloudfront.net/fit-in/203x114/production/premade-thumbnails/7.webp',
    'https://d2jefos38oys06.cloudfront.net/fit-in/203x114/production/premade-thumbnails/8.webp',
    'https://d2jefos38oys06.cloudfront.net/fit-in/203x114/production/premade-thumbnails/9.webp',
    'https://d2jefos38oys06.cloudfront.net/fit-in/203x114/production/premade-thumbnails/10.webp',
    'https://d2jefos38oys06.cloudfront.net/fit-in/203x114/production/premade-thumbnails/11.webp',
    'https://d2jefos38oys06.cloudfront.net/fit-in/203x114/production/premade-thumbnails/12.webp',
  ],
];



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/components/shareToUniverseModal/premadeThumbnailList.js